import { normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import commonTxt from './commonTxt.vue';
import { onMounted } from 'vue';
export default {
  __name: 'eTitle',
  props: {
    element: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    elementContent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['loaded'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 组件 */
    var props = __props;
    var emit = __emit;
    onMounted(function () {
      emit('loaded', 'eTitle');
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["custom-component title-element", {
          'title-border': __props.elementContent.title.style === 'simple'
        }])
      }, [_createVNode(commonTxt, {
        "initial-content": __props.elementContent.content,
        class: _normalizeClass('custom-paragraph-' + __props.element.elementType)
      }, null, 8, ["initial-content", "class"])], 2);
    };
  }
};